export enum MORE_ACTIONS_MENU_SIZES {
  Small = "144px",
}
